export default {"src":"/_next/static/media/cartIcon-disabled.3d646367.svg","height":100,"width":100};